interface FullPageErrorProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

export function FullPageError({ title, description, actionLabel, onAction }: FullPageErrorProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      <p className="text-sm text-muted-foreground">{description}</p>
      <button
        onClick={onAction}
        className="px-4 py-2 bg-primary text-primary-foreground rounded text-sm"
      >
        {actionLabel}
      </button>
    </div>
  );
}
